module.exports = __webpack_public_path__ + "img/banner3.d2fdcf46.jpg";